import _ from 'lodash';
import { DateTime } from 'luxon';

const adminUtils = {

  getCSVSubmitObj(readerResult, studyRoles, submitObj) {

    // console.log("DEBUGGING", readerResult)
    // console.log("DEBUGGING", studyRoles)
    // set our success variable
    submitObj.success = true;
    // setup variables
    let lineArrays = readerResult.replace(/\r?\n|\r/g,";").split(";") // breaks each line into an array
        , issueLines = ""
        , studyUsersArray = [];
    // make sure our headers match what we need them to be
    lineArrays.map((header, i) => {
      if(i === 0 && header !== "firstName,lastName,email,siteNumber,role,ssoType,viewAnalytics") {
        // console.log("header", header)
        submitObj.success = false;
        submitObj.message = "The CSV headers don't match the template, please download the sample template and edit your file and try again!";
        // return our object
        return submitObj;
      }
    });
    // if we only have one line, header, give error
    if(lineArrays.length === 1) {
      submitObj.success = false;
      submitObj.message = "Please make sure you have data populated in the CSV and try again!";
      // return our object
      return submitObj;
    }
    // check how many invalid emails we have
    let invalidEmails = [];
    lineArrays.slice(1).map((array, i) => {
      let itemArray = array.split(",");
      // console.log(itemArray);
      if(itemArray[2] && !this.validateEmail(itemArray[2].trim())) {
        invalidEmails.push(itemArray[2]);
      }
    });
    // don't let the users submit unless all emails are valid
    let invalidRoleUsers = [];
    let invalidAnalyticsUsers = [];

    if(invalidEmails.length > 0) {
      submitObj.success = false;
      // console.log('invalidEmails');
      // console.log(invalidEmails);
      submitObj.message = "We found a couple invalid email addresses. Please fix these errors and try again. Wrong emails: " + invalidEmails.join(", ")
      // return our object
      return submitObj;
    } else {

      // loop through each line - skipping the first line (headers)
      lineArrays.slice(1).map((array, i) => {
        // setup variables
        let itemArray = array.split(",") // split each line into is own array while looping through
          , lineIssue = ""
          , userObj = {};
        // loop through each item if email is valid
        // console.log(itemArray);
        itemArray.map((item, index) => {
          // setup our submit array
          // console.log(item, index, itemArray.length);
          if(index === 0 && item.trim().length > 0) {
            userObj.firstName = item.trim();
          }
          if(index === 1 && item.trim().length > 0) {
            userObj.lastName = item.trim();
          }
          // check if email is valid
          if(index === 2 && item.trim().length > 0 && this.validateEmail(item.trim())) {
            userObj.email = item.trim();
          }
          if(index === 3 && item.trim().length > 0) {
            userObj.siteNumber = item.trim();
          }
          if(index === 4 && item.trim().length > 0) {
            userObj.role = item.trim();

            // add checks to determine the _groupRole of this user as well
            // if it doesn't exist, throw errors
            for(let studyRole of studyRoles) {
              console.log(studyRole)
              if(studyRole.role == userObj.role) {
                userObj._groupRole = studyRole._id
              }
            }
          

          }
          if(index === 5 && item.trim().length > 0) {
            userObj.ssoType = item.trim();
          }
          if(index === 6 && item.trim().length > 0) {
            // userObj.viewAnalytics = item.trim();
            let viewAnalytics = item.trim();
            // console.log("DEBUG", viewAnalytics, !viewAnalytics, viewAnalytics.toLowerCase())

            // defaulting to false, may throw different errors in the future

            if(viewAnalytics && viewAnalytics.toLowerCase() == "true") {
              userObj.permissions.push('view-reports')
            }

          }
          if(itemArray.length > 1 && index + 1 === itemArray.length) {
            if(userObj._groupRole) {
              studyUsersArray.push(userObj);
            } else {
              submitObj.success = false;
              // console.log("MISSING!", userObj.email)
              invalidRoleUsers.push(userObj.email)
            }
          }
        });
      });
    }

    if(invalidRoleUsers.length > 0) {
      // console.log("DEBUG", invalidRoleUsers)
      submitObj.message = "We found a couple invalid user roles. Please fix these errors and try again. Emails with invalid roles: " + invalidRoleUsers.join(", ")
    } else if(invalidAnalyticsUsers.length > 0) {
      // console.log("DEBUG", invalidRoleUsers)
      submitObj.message = "We found a couple invalid viewAnalytics fields. Please fix these errors and try again. Emails: " + invalidAnalyticsUsers.join(", ")

    } else {
      // set array to our object
      submitObj.studyUsers = studyUsersArray;
    }
    // return our object
    return submitObj;
  }

  , validateEmail(email) {
    // console.log(email);
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    // console.log(re.test(email))
    return re.test(email);
  }

  , generateStudyUserExport(
    studyUsers 
    , userEvents 
    , courseMap  
    , studyRoleMap
  ) {
    // let groupedUserEvents = _.groupBy(userEvents, '_user')

    let csv = "";
    csv += `Email,Role,Site Number,Course,Created Date,Status\n`;

    for(const studyUser of studyUsers) {
      // const hasOnboarded = _.findIndex(userEvents, {eventAction: "onboarded"}) > -1;
      csv += `${studyUser.email}`;
      csv += `,${studyRoleMap[studyUser._groupRole] ? _.startCase(studyRoleMap[studyUser._groupRole].role) : 'n/a'}`;
      csv += `,${studyUser.siteNumber}`;
      csv += `,${courseMap[studyUser._course] ? courseMap[studyUser._course].title : 'Unassigned'}`;
      csv += `,${DateTime.fromISO(studyUser.created).toLocaleString(DateTime.DATE_SHORT)}`;
      csv += `,${studyUser.status}`;
      if(studyUser.status == 'deactivated') {
        csv += ` (${DateTime.fromISO(studyUser.dateRevoked).toLocaleString(DateTime.DATE_SHORT)})`;
      } else if(studyUser.status == 'expired' ) {
        csv += ` (${DateTime.fromISO(studyUser.expires).toLocaleString(DateTime.DATE_SHORT)})`;
      }        
      csv += `\n`;
    }
    return csv;
  }

  , generateModuleNodesTableViewExport(
    nodes 
    , scenes 
  ) {

    // must sanitize all strings for commas and double quotes, ALSO need to strip out '#' as well because it somehow terminates the csv when parsed.
    const sanitizeString = (string) => {
      if (!string) return "--";
      return this.replaceAllInString(string.trim(), [",", "#", '"'], "--");
    }

    const baseUrl = window.location.host;
    let csv = "";
    csv += `Authoring Code, Scene Title, Video Path, Scene Link, Created Date, Admin Notes, Answer, Checkpoint, Correct,Exit, Metric, Notes, Order Weight, Question, Randomize Follow Ups, Start, TOC, Topic Change\n`;
    for(const node of nodes) {
      const nodeScene = node._scene ? scenes.find(scene => scene._id == node._scene) : null;
      csv += `${sanitizeString(node.authoring.code)}`;
      csv += `,${nodeScene && nodeScene.title ? sanitizeString(nodeScene.title) : '--'}`;
      csv += `,${nodeScene && nodeScene.videoPath ? nodeScene.videoPath : '--'}`;
      // add `http://` prefix so it's clickable in excel, on prod it will redirect to https, but localhost is http
      csv += `,${nodeScene ? `http://${baseUrl}/admin/authoring/scenes/${nodeScene._id}` : '--'}`;
      csv += `,${DateTime.fromISO(node.created).toLocaleString(DateTime.DATE_SHORT)}`;
      csv += `,${sanitizeString(node.adminNotes)}`;
      csv += `,${node.answer}`;
      csv += `,${node.checkpoint}`;
      csv += `,${node.correct}`;
      csv += `,${node.exit}`;
      csv += `,${sanitizeString(node.metric)}`;
      csv += `,${sanitizeString(node.notes)}`;
      csv += `,${node.orderWeight}`;
      csv += `,${node.question}`;
      csv += `,${node.randomizeFollowUps}`;
      csv += `,${node.start}`;
      csv += `,${node.toc}`;
      csv += `,${node.topicChange}`;
      csv += `\n`;
    }
    return csv;
  }

  // replace all instances of a string in a string, used above to sanitize csv data
  , replaceAllInString(string, find, replace) {
    if(!string) return string;
    if(typeof find === 'string') {
      return string.split(find).join(replace);
    }
    if(Array.isArray(find)) {
      for(const f of find) {
        string = string.split(f).join(replace);
      }
      return string;
    }
  }
}

export default adminUtils;



// WEBPACK FOOTER //
// global/utils/adminUtils.js